export enum ELeadResponseType {
  EmailOpen = 'EMAIL_OPEN',
  EmailClick = 'EMAIL_CLICK',
  EmailReply = 'EMAIL_REPLY',
  AgentLandingOpen = 'AGENT_LANDING_OPEN',

  AgentLandingContactForm = 'AGENT_LANDING_CONTACT_FORM',
  AgentLandingPropertyReviewRequest = 'AGENT_LANDING_PROPERTY_REVIEW_REQUEST',
  AgentLandingMarketReportRequest = 'AGENT_LANDING_MARKET_REPORT_REQUEST',

  // For 'COMPARABLE_PROPERTIES' agent landing page type
  AgentLandingConsentForm = 'AGENT_LANDING_CONSENT_FORM',
  AgentLandingDownloadReport = 'AGENT_LANDING_DOWNLOAD_REPORT',
  AgentLandingEmailAgentForm = 'AGENT_LANDING_EMAIL_AGENT_FORM',
  AgentLandingSellForThisPriceForm = 'AGENT_LANDING_SELL_FOR_THIS_PRICE_FORM',
  AgentLandingPriceTooLowForm = 'AGENT_LANDING_PRICE_TOO_LOW_FORM',
  AgentLandingAssessmentForm = 'AGENT_LANDING_ASSESSMENT_FORM',

  // For 'DIGITAL_AD' agent landing page type
  AgentLandingZipCodeForm = 'AGENT_LANDING_ZIP_CODE_FORM',
}
